import { isEnabledForCurrentStage } from './featuresHelper';
import { features } from './constants';

export default class FeatureToggleManager {
  isEnabled(feature) {
    return isEnabledForCurrentStage(features[feature]?.environment);
  }
}
